import React, { useState, useMemo } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { MaterialReactTable } from "material-react-table";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import fetchData from "verticales/FetchData";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AppLoading from "verticales/AppLoading.tsx";
import dayjs from "dayjs";
import TableMaestros from "../../../verticales/TableMaestrosInformes.tsx";
import MDButton from "components/MDButton";
import { IconButton } from "@mui/material";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import Tooltip from "@mui/material/Tooltip";

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

interface Props {
  windowHeight: number;
}

const ViewConcurrencia: React.FC<Props> = (props) => {
  const [mesIni, setMesIni] = useState(dayjs().startOf("month"));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleGetConcurrencia = async () => {
    if (mesIni) {
      try {
        setLoading(true);
        const mesIniTimestamp = mesIni.valueOf();
        const mesFin = mesIni.clone().add(1, "month").startOf("month");
        const mesFinTimestamp = mesFin.valueOf();

        const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
        const context = "informes";
        const requestPayload = {
          mesIni: mesIniTimestamp,
          mesFin: mesFinTimestamp,
          action: "companias-activas",
        };

        const respData = await fetchData(url, context, requestPayload);
        console.log("Datos recibidos:", respData);

        if (respData && respData.rows) {
          const datos = respData.rows.map((row) => ({
            cuenta: row.cuenta,
            cliente: row.cliente,
            rds_id: row.rds_id,
            endpoint: row.endpoint,
            name_database: row.name_database,
            fecha_creacion: row.fecha_creacion.split("T")[0],
            nit: row.nit,
            razon_social: row.razon_social,
            estado_compania: row.estado_compania,
            estado: row.estado,
          }));
          console.log("Datos para la tabla:", datos);
          setData(datos);
        } else {
          console.error("La respuesta no contiene datos esperados:", respData);
        }
      } catch (error) {
        console.error("Error al obtener concurrencia:", error);
      } finally {
        setLoading(false);
      }
    } else {
      alert("Por favor, selecciona el mes de inicio.");
    }
  };

  const columns = useMemo(
    () => [
      { header: "Cuenta", accessorKey: "cuenta" },
      { header: "Nit", accessorKey: "nit" },
      { header: "Razon Social", accessorKey: "razon_social" },
      { header: "Fecha Creacion", accessorKey: "fecha_creacion" },
      { header: "Id Rds", accessorKey: "rds_id" },
      { header: "Base de Datos", accessorKey: "name_database" },
      { header: "Estado BD", accessorKey: "estado" },
      {
        header: "Estado Compañia",
        accessorKey: "estado_compania",
        filterVariant: "multi-select",
        filterSelectOptions: Array.from(new Set(data.map((row) => row.estado_compania))),
        filterFn: (row, columnId, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return true; // Si no hay filtro, muestra todos los datos
          }
          return filterValue.includes(row.getValue(columnId)); // Aplica filtro exacto
        },
      },
    ],
    [data]
  );

  const customTableContainerProps = {
    sx: {
      maxHeight: "300px", // Altura máxima de la tabla
      overflow: "auto",
    },
  };

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };
  let renderOpcRowsSid = (row) => {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%", padding: "0" }}></Box>
    );
  };

  return (
    <React.Fragment>
      <div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box components={["DatePicker"]}>
            <DatePicker
              label={"Mes y año"}
              views={["month", "year"]}
              onChange={(newValue) => setMesIni(newValue?.startOf("month"))}
              value={mesIni}
            />
            <Box sx={{ display: "absolute", flexWrap: "wrap" }}>
              <MDButton
                color="info"
                variant="contained"
                size="large"
                onClick={handleGetConcurrencia}
              >
                Compañias
              </MDButton>
            </Box>
          </Box>
        </LocalizationProvider>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
            }}
          >
            <AppLoading titleCustom={"Compañias"} />
          </Box>
        ) : (
          <Box sx={{ maxHeight: "calc(100vh - 100px)", overflow: "auto" }}>
            <TableMaestros
              renderOpcRows={renderOpcRowsSid}
              height={320}
              arrayColumns={columns}
              data={data}
              enableColumnResizing
              enableGrouping
              enableStickyHeader
              enableStickyFooter
              initialState={{
                density: "compact",
                expanded: true,
                pagination: { pageIndex: 0, pageSize: 30 },
                columnFilters: [
                  { id: "estado_compania", value: [] }, // Sin filtro inicial (mostrar todos)
                ],
              }}
              muiToolbarAlertBannerChipProps={{ color: "primary" }}
              muiTableContainerProps={customTableContainerProps}
              renderTopToolbarCustomActions={({ table }) => (
                <Box sx={{ display: "absolute", gap: "150px", padding: "2px", flexWrap: "wrap" }}>
                  <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
                    Export All Data
                  </Button>
                </Box>
              )}
            />
          </Box>
        )}
      </div>
    </React.Fragment>
  );
};

export default ViewConcurrencia;
